import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Api from "api/Api";
import { selectCompanyInfo } from "store/companySlice";
import { closeModal } from "store/modalsSlice";

import Button from "layout/atoms/Button";
import ContentBox from "layout/atoms/ContentBox";
import Modal from "layout/atoms/Modal";
import PriceBox from "layout/atoms/PriceBox";

import PayPalIcon from "assets/paypal.png";

const api = new Api();

const CheckoutModal = ({ pickedPlan }) => {
  const dispatch = useDispatch();
  const companyInfo = useSelector(selectCompanyInfo);
  const { t } = useTranslation("translation");

  const handleClose = () => dispatch(closeModal("checkoutModal"));

  const handlePayClick = () => {
    api.upgradeCompanySubscription(companyInfo.id, {
      product: pickedPlan.product,
      channel: "PAYPAL",
      amount: pickedPlan.discountedPrice
        ? pickedPlan.discountedPrice.amount
        : pickedPlan.price.amount,
      months: pickedPlan.months,
    }).then((response) => {
      response.link && window.location.replace(response.link);
    }).catch((error) => console.log("error: " + error));
  };

  return (
    <Modal open onClose={handleClose}>
      <ContentBox
        size="m"
        header={<h3>{t("subscription.checkout.header")}</h3>}
        footer={
          <>
            <div />
            <div>
              <Button size="lg" color="white" onClick={handleClose}>
                {t("buttons.cancel")}
              </Button>
              <Button type="submit" size="lg" color="primary" onClick={handlePayClick}>
                {t("subscription.checkout.payButton")}
              </Button>
            </div>
          </>
        }
      >
        <h4>{t("subscription.checkout.pickedPlan")}</h4>
        <br />
        <PriceBox
          key={pickedPlan.product}
          picked={true}
          readOnly={true}
          name={pickedPlan.product}
          description={
            <p>
              {t("subscription.checkout.for")} {pickedPlan.months}{" "}
              {t(`subscription.checkout.months.${pickedPlan.months > 1 ? "plural" : "singular"}`)}
            </p>
          }
          months={pickedPlan.months}
          price={pickedPlan.discountedPrice ? pickedPlan.discountedPrice.amountMinor / 100 : pickedPlan.price.amountMinor / 100}
          discountPrice={pickedPlan.discountedPrice ? pickedPlan.price.amountMinor / 100 : null}
        />
        <br />
        <br />
        <h4>{t("subscription.checkout.paymentMethod")}</h4>
        <br />
        <img src={PayPalIcon} width="200px" />
      </ContentBox>
    </Modal>
  );
};

CheckoutModal.propTypes = {
  pickedPlan: PropTypes.object,
};

export default CheckoutModal;
